import React, { Component } from 'react'
import { Styled } from './VitrinePortoPlus.styled'

import { Coin, Credit, CashBack } from 'components/NewIcons/NewIcons'

let List = [
  {
    icons: <Coin />,
    title: ' Descontos produtos Porto',
    subTile: 'Resgate a partir de 5.000 pontos.',
  },
  {
    icons: <Credit />,
    title: ' Compre com desconto',
    subTile: 'Parceiros com descontos especiais.',
  },
  {
    icons: <CashBack />,
    title: 'Experiências e Viagens',
    subTile: 'Troque seus pontos por eventos e mais.',
  },
]

const VitrinePortoPlus = () => {
  return (
    <Styled.Content>
      <Styled.txtInfo>
        Com o PortoPlus você acumula pontos e troca por muito mais vantagens
      </Styled.txtInfo>
      <Styled.CardGroup>
        {List.map((itens, i) => {
          return (
            <Styled.Card>
              <Styled.Icons>{itens.icons}</Styled.Icons>
              <Styled.ContentTxt>
                <Styled.Title>{itens.title}</Styled.Title>
                <Styled.SubTitle>{itens.subTile}</Styled.SubTitle>
              </Styled.ContentTxt>
            </Styled.Card>
          )
        })}
      </Styled.CardGroup>
    </Styled.Content>
  )
}

export default VitrinePortoPlus
